import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MoneyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"money"}/>
}
